import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SessionProvider } from "./context/sessionContext";
import { SurveyProvider } from "./context/surveyContext";
import { UserProvider } from "./context/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SessionProvider>
      <SurveyProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </SurveyProvider>
    </SessionProvider>
  </React.StrictMode>
);
reportWebVitals();
